module.exports = __webpack_public_path__ + "img/fl-icon.63882de7.svg";